/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-theme-base/src';
import { Link } from '@bottlebooks/gatsby-theme-base/src';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

/**
 *
 * @param {object} props
 * @param {object} props.producer
 * @param {string} [props.to]
 * @param {string} [props.href]
 * @param {() => void} [props.onClick]
 */
export default function ProductProducerName({
  producer,
  to,
  href,
  onClick,
  ...rest
}) {
  if (!producer) return null;
  return (
    <Text {...rest} className="notranslate">
      <Link
        to={to}
        onClick={onClick}
        href={href}
        sx={{ color: 'lightestText' }}
      >
        {producer.name}
      </Link>
    </Text>
  );
}

export const fragment = graphql`
  fragment ProductProducerName on Product {
    producer {
      name
    }
  }
`;

export const ProductProducerNameFragment = gql`
  fragment ProductProducerName on Product {
    producer {
      name
    }
  }
`;
